/* eslint-disable @typescript-eslint/naming-convention */
/**
 * HTML IDs for general app elements
 */
export enum AppId {
    LOADING = 'sails-loading-spinner',
    OVERLAY_LOADING = 'overlay-loading-spinner',
    APP = 'fixnet-app-wrapper',
    OVERLAY = 'fixnet-overlay',
    ERROR = 'fixnet-error-wrapper',
    LINKS_LIST = 'fixnet-links-list',
    RELATED_LINKS = 'fixnet-related-links',
    RELATED_LINKS_OFFERS = 'fixnet-related-links-offers',
    ICON_TEXT_BANNER = 'fixnet-icon-text-banner',
    SEAL_IMG = 'fixnet-seal-product',
    FLOATING_BUTTON = 'floatin-notification-button',
    FLOATING_NOTIFICATION = 'floating-mobile-notification',
    LINEAR_STEPPER = 'fixnet-linear-stepper',
    IMAGE_HEADER = 'cable-header',
}

/**
 * HTML IDs for CMS content parts
 */
export enum ContentId {
    FAQ_ACCORDION = 'faq-accordion',
    FOOTNOTE_ACCORDION = 'fixnet-footnote-accordion',
    FOOTNOTE_DYNAMIC_ITEM = 'accordion-dynamic-item',
    FOOTNOTE_FNF_ACCORDION = 'ws10-accordion-item-details-fnf-footnote',
    FOOTNOTE_PS_ACCORDION = 'ws10-accordion-item-details-ps-footnote',
    PS_ACCORDION = 'ps-footnote',
    FNF_ACCORDION = 'fnf-footnote',
    SUMMARYCARD_LEGALTEXT_WRAPPER = 'ws10-offer-summary-card__legal-text',
}

/**
 * HTML IDs for avc app elements
 */
export enum AvcId {
    AVC_FORM = 'fixnet-avc-wrapper',
    AVC_CAPTCHA = 'fixnet-avc-captcha-wrapper',
    AVC_RESULT = 'fixnet-avc-result-wrapper',
}

/**
 * HTML IDs for avc form elements
 */
export enum AvcFormId {
    SUBLINE_TOOLTIP = 'avc-subline-tooltip-wrapper',
    ADDRESS_ERROR = 'avc-address-error',
    SERVICE_ERROR = 'avc-service-error',
    MULTIPLE_ADDRESS = 'avc-form-multiple-address-wrapper',
    MULTIPLE_ADDRESS_SELECT = 'avc-form-select-wrapper',
    CITY_INPUT = 'avc-form-input-city-wrapper',
    STREET_INPUT = 'avc-form-input-street-wrapper',
    HOUSE_INPUT = 'avc-form-input-house-wrapper',
    MOVE_CASE_TOOLTIP = 'avc-move-tooltip-wrapper',
    BUTTON = 'avc-form-button',
}

/**
 * HTML IDs for avc result elements
 */
export enum AvcResultId {
    CHECKED_ADDRESS = 'avc-result-checked-address',
    CHANGE_ADDRESS_BUTTON = 'avc-result-change-address-button',
    NOTIFICATION = 'avc-result-notification',
    UPSELL = 'avc-result-upsell-wrapper',
    UPSELL_TEXT = 'avc-result-upsell-text',
    BUTTON = 'avc-result-button',
}

/**
 * HTML IDs for customer info elements
 */
export enum CustomerInfoId {
    WRAPPER = 'fixnet-customer-info',
    NAME = 'fixnet-customer-name',
    CITY = 'fixnet-customer-city',
    STREET_AND_HOUSE = 'fixnet-customer-street',
    CUSTOMER_NUMBER = 'fixnet-customer-number',
}

/**
 * HTML IDs for legal overlay elements
 */
export enum LegalId {
    WRAPPER = 'fixnet-legal-wrapper',
    TEXT = 'fixnet-legal-tv-connect-text',
    LOGIN_LINK = 'fixnet-legal-tv-login-link',
    FOOTNOTE_HEADLINE = 'fixnet-tv-connect-footnote-headline',
    FOOTNOTE_TEXT = 'fixnet-tv-connect-footnote-text',
    WITH_TV_CONNECT_BTN = 'fixnet-with-tv-connect-btn-wrapper',
    WITHOUT_TV_CONNECT_BTN = 'fixnet-without-tv-connect-btn-wrapper',
    DISCOUNTED_PRICE = 'fixnet-legal-tv-connect-price',
}

/**
 * HTML IDs for lm for elements
 */
export enum LmFormId {
    WRAPPER = 'fixnet-lm-form-wrapper',
    ERROR_NOTIFICATION = 'fixnet-notification-lm-error-wrapper',
    SUCCESS_NOTIFICATION = 'fixnet-notification-lm-result-wrapper',
    FORM = 'fixnet-lm-form-section-wrapper',
    FORM_INPUT_TITLE = 'fixnet-lm-title-input-wrapper',
    FORM_INPUT_FIRSTNAME = 'fixnet-lm-firstname-input-wrapper',
    FORM_INPUT_LASTNAME = 'fixnet-lm-lastname-input-wrapper',
    FORM_INPUT_EMAIL = 'fixnet-lm-email-input-wrapper',
    FORM_BUTTON = 'fixnet-lm-submit-btn-wrapper',
}

/**
 * HTML IDs for lm module elements
 */
export enum LmModuleId {
    MODULE_CONTAINER = 'fixnet-ftth-lm-module-wrapper',
    MODULE_SUCCESS_CONTAINER = 'fixnet-ftth-lm-module-success-wrapper',
    REGISTER_LINK = 'fixnet-ftth-lm-register-link',
}

/**
 * HTML IDs for checked address elements
 */
export enum CheckedAddressId {
    ADDRESS_WRAPPER = 'fixnet-checked-address-wrapper',
    ADDRESS_TEXT = 'fixnet-checked-address',
    CHANGE_ADDRESS = 'fixnet-change-address-button',
    DELETE_ADDRESS = 'fixnet-delete-address-button',
}

/**
 * HTML IDs for discount elements
 */
export enum DiscountId {
    RESIDENT_PLUS_CARD = 'fixnet-resident-plus-discount-card',
    RESIDENT_PLUS_CARD_HEADLINE_BONUS = 'fixnet-resident-plus-headline-bonus',
    RESIDENT_PLUS_CARD_SUBLINE_BONUS = 'fixnet-resident-plus-subline-bonus',
    RESIDENT_PLUS_CARD_TOOLTIP = 'fixnet-resident-plus-tooltip-wrapper',
    GIGAKOMBI_BONUS_TEXT = 'fixnet-gigakombi-bonus-text',
    GIGAKOMBI_BONUS_PRICE = 'fixnet-gigakombi-bonus',
    GIGAKOMBI_PICKER = 'fixnet-gigakombi-picker',
    GIGAKOMBI_ADDITIONAL_TEXT = 'fixnet-gigakombi-additional-text',
    TV_CONNECT_PICKER_WRAPPER = 'fixnet-tv-connect-picker-wrapper',
    TV_CONNECT_PICKER = 'fixnet-tv-connect-picker',
    TV_CONNECT_DISCOUNTED_PRICE_TEXT = 'fixnet-tv-connect-price-text',
    YOUNG_PICKER = 'fixnet-young-picker',
    YOUNG_PICKER_TEXT = 'fixnet-young-picker-text',
    YOUNG_ADDITIONAL_TEXT = 'fixnet-young-additional-text',
    FREE_WIFI = 'fixnet-free-wifi-card',
    CASH_BACK = 'fixnet-cashback-promotion',
    PLAYSTATION_PROMO_CARD = 'fixnet-kip-cablemax-ps-card',
    PS_LINK = 'fixnet-playstation-card-link',
    PS_BANNER = 'fixnet-kip1000-ps',
    CASH_BACK_DISABLED = 'fixnet-cashback-promotion-disbaled',
    UPSELL_LINK = 'fixnet-casback-card-link',
}

/**
 * HTML IDs for offer summary card elements
 */
export enum OfferSummaryCardId {
    OFFER_SUMMARY_CARD_WRAPPER = 'fixnet-offer-summary-card',
    CABLE_CONNECTION_MODULE = 'offer-summary-card-cable-connection',
}

/**
 * HTML IDs for tariff card elements
 */
export enum TariffCardId {
    TARIFF_PICKER = 'fixnet-tariff-picker',
    TARIFF_BENEFITS_WRAPPER = 'fixnet-cable-benefits-wrapper',
    TARIFF_BENEFITS = 'fixnet-cable-benefits',
}

/**
 * Kip1000CableMax
 */
export enum Kip1000CableMax {
    BV = 'kip-1000-cablemax-bv',
    BV_UM = 'kip-1000-cablemax-bv-um',
    UM = 'kip-1000-cablemax-um',
  }

/**
 * HTML IDs for all elements
 */
export type HtmlId =
    AppId |
    AvcId |
    AvcFormId |
    AvcResultId |
    ContentId |
    DiscountId |
    TariffCardId |
    OfferSummaryCardId |
    CheckedAddressId |
    LegalId |
    LmModuleId |
    Kip1000CableMax |
    LmFormId;
